const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div id="prototype-clouds">
  <div class="o-container o-container--prose t-dark" style="padding: 1em;">
    <div class="o-container__content">
      <h1>Cooperative Design Systems</h1>
      <p>Stop me if you’ve heard this one before: There once was an organization whose products lacked harmony. Its teams struggled to embrace a shared vision, continuously reinventing wheels of infinitely varied size and shape. Then one day they all joined hands and created the Design System, addressing everyone’s needs and forever banishing the dissonance they’d felt for so long.</p>
    </div>
  </div>
  <div class="o-container o-container--prose t-dark">
    <div class="p-clouds">
      <div class="p-clouds__side p-clouds__side--left">
        <img src="clouds/cloud-white-left.svg" role="presentation" class="p-cloud p-top">
        <img src="clouds/cloud-light-blue.svg" role="presentation" class="p-cloud p-middle">
        <img src="clouds/cloud-blue-left.svg" role="presentation" class="p-cloud p-back">
      </div>
      <div class="p-clouds__side p-clouds__side--right">
        <img src="clouds/cloud-white-right.svg" role="presentation" class="p-cloud p-top">
        <img src="clouds/cloud-light-blue.svg" role="presentation" class="p-cloud p-middle">
        <img src="clouds/cloud-blue-right.svg" role="presentation" class="p-cloud p-back">
      </div>
    </div>
  </div>
  <div class="o-container o-container--prose" style="padding: 1em;">
    <div class="o-container__content">
      <h1>Cooperative Design Systems</h1>
      <p>Stop me if you’ve heard this one before: There once was an organization whose products lacked harmony. Its teams struggled to embrace a shared vision, continuously reinventing wheels of infinitely varied size and shape. Then one day they all joined hands and created the Design System, addressing everyone’s needs and forever banishing the dissonance they’d felt for so long.</p>
    </div>
  </div>
  <div class="o-container o-container--hero t-dark">
    <div class="o-container__content">
      <div class="Grid Grid--alignMiddle u-space-block-end-1">
        <div class="Grid-cell u-md-size1of2 u-padSides1 u-md-padSidesNone u-md-flexOrderLast">
          <img class="p-hero__image" src="https://29comwzoq712ml5vj5gf479x-wpengine.netdna-ssl.com/wp-content/themes/cloudfour/static/toolkit/images/sky-what_we_do.svg" alt="">
        </div>
        <div class="Grid-cell u-md-size1of2 u-pad-block-end-1 u-pad-block-start-1">
          <h1 class="u-textGrow3">What We Do</h1>
          <p class="u-textGrow1">
            We <svg viewBox="0 0 24 24" width="24" height="24" class="c-icon u-spaceSides06" aria-labelledby="what_we_do-heart-title"><title id="what_we_do-heart-title">love</title><path d="M12,22.25C24.46,13.54,24,10.48,24,8.07a5.75,5.75,0,0,0-6-5.32c-3.75,0-6,3.54-6,3.54S9.75,2.76,6,2.76A5.75,5.75,0,0,0,0,8.07C0,10.48-.46,13.54,12,22.25Z"></path></svg>
            solving tough puzzles through design and&nbsp;code.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="o-container o-container--prose" style="padding: 1em;">
    <div class="o-container__content">
      <h1>Cooperative Design Systems</h1>
      <p>Stop me if you’ve heard this one before: There once was an organization whose products lacked harmony. Its teams struggled to embrace a shared vision, continuously reinventing wheels of infinitely varied size and shape. Then one day they all joined hands and created the Design System, addressing everyone’s needs and forever banishing the dissonance they’d felt for so long.</p>
    </div>
  </div>
  <div class="o-container o-container--hero t-dark">
    <div class="o-container__content">
      <div class="Grid Grid--alignMiddle u-space-block-end-1">
        <div class="Grid-cell u-md-size1of3 u-lg-size1of2 u-pad-block-end-1 u-pad-block-start-1">
          <h1 class="u-textGrow3">Articles</h1>
          <p class="u-textGrow1">Tales from the edge of the web</p>
        </div>
        <div class="Grid-cell u-md-size2of3 u-lg-size1of2">
          <form class="Grid Grid--withGutter Grid--alignEnd">
            <div class="Grid-cell u-sm-sizeFill">
              <label class="c-label" for="mce-EMAIL">Your Email Address</label>
              <input type="email" class="c-input" id="mce-EMAIL" name="EMAIL" autocomplete="home email" required="" value="">
            </div>
            <div class="Grid-cell u-sm-sizeFit">
              <button class="c-button c-button--primary u-sizeFull">
                Get Weekly Digests
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
`);
            }

            getTemplateName() {
                return `b0e176d6a68018f23ed99c487a0f8511a401e390056df55a466e3feecac61147`;
            }

            getSourceContext() {
                return new this.Source(``, `b0e176d6a68018f23ed99c487a0f8511a401e390056df55a466e3feecac61147`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'b0e176d6a68018f23ed99c487a0f8511a401e390056df55a466e3feecac61147');

let template = env.loadTemplate('b0e176d6a68018f23ed99c487a0f8511a401e390056df55a466e3feecac61147');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/prototypes/cloud-divider/example/example.twig", args: context }
     );
     return rendered;;
};